var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainWrapper", attrs: { id: "top" } },
    [
      _c("head-nav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _c("div", { staticClass: "innerWrapper" }, [
        _c("h1", [_vm._v("FAQ's")]),
        _vm._v(" "),
        _c("h2", [
          _vm._v("\n      Contact us at\n      "),
          _c(
            "a",
            { attrs: { target: "_blank", href: "mailto:" + _vm.contactEmail } },
            [_vm._v(_vm._s(_vm.contactEmail))]
          ),
          _vm._v("\n      for other general enquiries not listed below.\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.faqs, function(faq, index) {
            return _c("div", { key: index, staticClass: "faq" }, [
              _c(
                "div",
                {
                  staticClass: "qes",
                  on: {
                    click: function($event) {
                      return _vm.shrink(faq.id)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "newspan" }, [
                    _vm._v(_vm._s(faq.title))
                  ]),
                  _vm._v(" "),
                  _c("i", { class: { active: faq.spread } })
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "ans",
                class: { spread: faq.spread },
                domProps: { innerHTML: _vm._s(faq.text) }
              })
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("foot-nav", { attrs: { showQus: false } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5994ec3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5994ec3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq/faq.vue
// module id = null
// module chunks = 